// import '@gjensidige/core-fonts';

import React from 'react';
import { Expandable, Flex, Text, Title } from '@gjensidige/builders-components';
import { DateRange, Phone } from '@gjensidige/builders-icons';

import { MyPagesFeaturesCallMe } from './feature';
import { WorkingHours } from './feature/types';
import { EnonicDataType } from './feature/types';
import { MyPagesFeaturesCallMeLater } from './feature/lib/MyPagesFeaturesCallMeLater';

interface AppProps {
  configs: EnonicDataType;
}

export function App({ configs }: AppProps) {
  return (
    <Flex
      center
      justify="center"
      direction="column"
      className="call-me-wrapper"
    >
      <Title as="h5">Vill du prata med en rådgivare?</Title>
      <Expandable variant="white-white" className="call-me-expandable">
        <Expandable.Title>
          <Phone className="header-icon" />
          Ring nu
        </Expandable.Title>
        <Expandable.Content>
          <MyPagesFeaturesCallMe configs={configs} />
        </Expandable.Content>
      </Expandable>
      <Expandable variant="white-white" className="call-me-expandable">
        <Expandable.Title>
          <DateRange className="header-icon" />
          Bli uppringd senare
        </Expandable.Title>
        <Expandable.Content>
          <MyPagesFeaturesCallMeLater isScheduledCall configs={configs} />
        </Expandable.Content>
      </Expandable>
    </Flex>
  );
}

export default App;
